'use client';

import { c as _c } from "react/compiler-runtime";
import { signOut } from 'next-auth/react';
import { useRouter, usePathname } from 'next/navigation';
import signOutAction from '@/app/_lib/actions/SignOutAction';
import { useGlobalMessage } from '@/app/_lib/hooks';
const SignOutButton = t0 => {
  const $ = _c(8);
  const {
    children,
    className
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const showToast = useGlobalMessage();
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== showToast) {
    t1 = async () => {
      const needsRedirect = pathname.startsWith("/checkout") || pathname.startsWith("/account");
      if (needsRedirect) {
        router.push("/");
      }
      await signOutAction();
      await signOut({
        redirect: false
      });
      if (!needsRedirect) {
        router.refresh();
      }
      showToast({
        message: "You have been signed out",
        messageType: "success"
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = showToast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== children || $[5] !== className || $[6] !== handleClick) {
    t2 = <button className={className} onClick={handleClick} type="submit">{children}</button>;
    $[4] = children;
    $[5] = className;
    $[6] = handleClick;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default SignOutButton;